<template>
  <div
    class="flex flex-col"
    :style="{ 'background-color': branding.backgroundColor }"
  >
    <div class="flex justify-center px-4">
      <rating-body
        v-if="!ratingFinish"
        class="flex flex-col"
        @ratingFinished="changeView"
      />
      <div v-else class="flex flex-col">
        <div class="flex justify-center text-secondary space-y-4 py-4">
          <div class="flex justify-center text-2xl">
            <div class="font-bold uppercase">
              {{ $t("thank-you") }}
            </div>
          </div>
          <div class="flex justify-center">
            {{ $t("rating-received") }}
          </div>
          <div class="flex justify-center text-xl py-2 uppercase font-semibold">
            {{ $t("come-again") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RatingBody from "./RatingBody.vue";
import { authStore } from "../stores/auth";
import { mapState } from "pinia";

export default {
  name: "RatingPage",
  components: {
    RatingBody,
  },
  data() {
    return {
      ratingFinish: false,
    };
  },
  methods: {
    changeView() {
      this.ratingFinish = true;
    },
  },
  computed: {
    ...mapState(authStore, ["branding", "organization"]),
    visitId() {
      return this.$route.query.visitId;
    },
    rating() {
      return parseInt(this.$route.query.rate);
    },
  },
};
</script>

<style></style>
